import { FC } from 'react';

import { ReactComponent as Support } from 'assets/icons/24-support.svg';
import { ReactComponent as Like } from 'assets/icons/like.svg';
import { ReactComponent as People } from 'assets/icons/people.svg';
import { ReactComponent as Profile } from 'assets/icons/profile.svg';
import clientLogosHero from 'assets/images/clients-logos-hero.png';

import WhyChooseJoblio from './WhyChooseJoblio';

const items = [
  {
    label: '100% Free',
    text: 'Joblio is always free for job seekers — no one should ever have to pay for their path to success.',
    icon: <Like />
  },
  {
    label: 'No Middlemen',
    text: 'Find jobs or have employers discover you. Ask questions directly, and our team will assist with any disputes.',
    icon: <Profile />
  },
  {
    label: '24/7 Support',
    text: 'From the moment you apply to your first day and beyond, we’re by your side, making sure you’re prepared to succeed in your new role.',
    icon: <Support />
  },
  {
    label: 'Smart Matching',
    text: 'Our smart matching technology that automatically matches your skills with the right roles and opportunities.',
    icon: <People />
  }
];

interface WhyWorkersChooseJoblio {
  highlightColor?: 'yellow' | 'blue';
  componentToShowOnMobile?: React.ReactNode;
  backgroundColor?: string;
}

const WhyWorkersChooseJoblio: FC<WhyWorkersChooseJoblio> = ({
  highlightColor = 'yellow',
  componentToShowOnMobile,
  backgroundColor
}: WhyWorkersChooseJoblio) => {
  return (
    <WhyChooseJoblio
      title="Why workers"
      benefits={items}
      imageSrc={clientLogosHero}
      imagePosition="left"
      highlightColor={highlightColor}
      backgroundColor={backgroundColor}
      componentToShowOnMobile={componentToShowOnMobile}
    />
  );
};

export default WhyWorkersChooseJoblio;
